import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { Component, OnInit, Input } from "@angular/core";

import { TokenStorageService } from "src/app/_services/token-storage.service";
import { Router } from "@angular/router";
import { ClaveService } from "src/app/_services/clave.service";
import { SamlRequest } from "src/app/model/samltoken";
import { ServicioGeneral } from "src/app/_services/servicio-general.service";
import { NotificationReadService } from "src/app/_services/notificacion-read.service";
import { ClientLoaderService } from "src/app/core/util/client-loader.service";

@Component({
  selector: "app-header-emvs",
  templateUrl: "./header-emvs.component.html",
  styleUrls: ["./header-emvs.component.css"],
})
export class HeaderEmvsComponent extends UnsubscribeOnDestroy implements OnInit {
  //@Input() RolUsuario: RolUsuario;

  private roles: string[] = [];
  isLoggedIn = false;
  showAdminBoard = false;
  showModeratorBoard = false;
  usuario: any = [];
  miData: any = [];
  totalNotificaciones;
  mobileNavOpen = false;
  logoHeaderUrl = '';
  loginType: string = 'clave';

  constructor(
    private tokenStorageService: TokenStorageService,
    private _claveservice: ClaveService,
    private router: Router,
    private notificacionService: NotificationReadService,
    private clientLoader: ClientLoaderService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.logoHeaderUrl = this.clientLoader.getClientImage('header');
    this.loginType = this.clientLoader.getLoginType();
    this.isLoggedIn = !!this.tokenStorageService.getToken();

    if (this.isLoggedIn) {
      //this.getRolUsuario();
      const user = this.tokenStorageService.getUser();
      this.checkNotificaciones();
      this.usuario = user;
    }
  }

  logout(): void {
    this.tokenStorageService.signOut();
    window.location.reload();
  }

  isVisible = true;

  toggleDisplay() {
    this.isVisible = !this.isVisible;
  }

  toggleMobileNav(): void {
    this.mobileNavOpen = !this.mobileNavOpen;
  }

  reload() {
    this.router.navigateByUrl("/login");
  }

  /*
    getRolUsuario() {
      return this.serviciogeneral.getRolUsuario()
        .pipe(takeUntil(this.destroy$))
        .subscribe((data) => {
        this.miData = data;     
      });
    }
    */

  checkNotificaciones() {
    this.notificacionService
      .getAlertMap()
      
        .pipe(takeUntil(this.destroy$))
        .subscribe((map: Map<string, string>) => {
        this.totalNotificaciones = map.get("totales");
      });
  }

  redireccion(): void {
    this._claveservice.getSamlRequest()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
      next: async (data: SamlRequest) => {
        this.post(data.nodeService, {
          SAMLRequest: data.SamlRequest,
          RelayState: data.RelayState,
        });
      },
    });
  }

  post(path: string, params: any): void {
    let method = "post";
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
  }
  navegaSeccion(ruta: string){
    this.router
    .navigate(["inicio"], { skipLocationChange: true })
    .then(() => {
      this.router.navigateByUrl(ruta);
    });
  }
}
